import React from 'react';
import { useTranslation } from 'react-i18next';
import { RegularButton, Typography } from 'fronton-react';
import { KeycardWrapper, IconsLine, TextLine } from './styles';
import { KeycardKey } from '../../icons/keycard-key';
import { KeycardHole } from '../../icons/keycard-hole';

interface IKeycard {
  title: string;
  label: string;
  pro?: boolean;
  onCreate: () => void;
}

export const Keycard: React.FC<IKeycard> = ({ title, label, pro = false, onCreate }) => {
  const { t } = useTranslation();

  return (
    <KeycardWrapper pro={pro}>
      <IconsLine pro={pro}>
        <KeycardKey data-qa="keyacrd-key-icon" />
        <KeycardHole data-qa="keyacard-hole-icon" />
      </IconsLine>
      <TextLine>
        <Typography variant="h3" color={pro ? 'text-primary-invert' : 'text-primary'}>
          {title}
        </Typography>
        <Typography variant="m" size="body_short" color={pro ? 'text-primary-invert' : 'text-primary'}>
          {label}
        </Typography>
      </TextLine>
      <RegularButton
        data-qa={`choose-card-button-${pro ? 'pro' : 'home'}`}
        variant="primary"
        invert
        wide
        onClick={onCreate}
      >
        {t('loyalty-registration-modal.choose-keycard-step.choose-this-card')}
      </RegularButton>
    </KeycardWrapper>
  );
};
